import { j as jsxRuntimeExports, M as MathJax } from "./doenetml-CDvV96YD.js";
import React__default, { useState, useRef } from "react";
import { u as useDoenetRenderer } from "./useDoenetRenderer-YzDSBjpZ.js";
import { c as calculateValidationState, a as createCheckWorkComponent } from "./checkWork-ELAyU3CF.js";
const choiceInput = React__default.memo(function ChoiceInput(props) {
  let { id, SVs, actions, children, ignoreUpdate, callAction } = useDoenetRenderer(props);
  ChoiceInput.baseStateVariable = "selectedIndices";
  const [rendererSelectedIndices, setRendererSelectedIndices] = useState(SVs.selectedIndices);
  let selectedIndicesWhenSetState = useRef(null);
  if (!ignoreUpdate && selectedIndicesWhenSetState.current !== SVs.selectedIndices) {
    setRendererSelectedIndices(SVs.selectedIndices);
    selectedIndicesWhenSetState.current = SVs.selectedIndices;
  } else {
    selectedIndicesWhenSetState.current = null;
  }
  const validationState = calculateValidationState(SVs);
  const submitAnswer = () => callAction({
    action: actions.submitAnswer
  });
  function onChangeHandler(e) {
    let newSelectedIndices = [];
    if (SVs.inline) {
      if (e.target.value) {
        newSelectedIndices = Array.from(
          e.target.selectedOptions,
          (option) => Number(option.value)
        );
      }
    } else {
      if (SVs.selectMultiple) {
        newSelectedIndices = [...rendererSelectedIndices];
        let index = Number(e.target.value);
        if (e.target.checked) {
          if (!newSelectedIndices.includes(index)) {
            newSelectedIndices.push(index);
            newSelectedIndices.sort((a, b) => a - b);
          }
        } else {
          let i = newSelectedIndices.indexOf(index);
          if (i !== -1) {
            newSelectedIndices.splice(i, 1);
          }
        }
      } else {
        newSelectedIndices = [Number(e.target.value)];
      }
    }
    if (rendererSelectedIndices.length !== newSelectedIndices.length || rendererSelectedIndices.some((v, i) => v != newSelectedIndices[i])) {
      setRendererSelectedIndices(newSelectedIndices);
      selectedIndicesWhenSetState.current = SVs.selectedIndices;
      callAction({
        action: actions.updateSelectedIndices,
        args: {
          selectedIndices: newSelectedIndices
        },
        baseVariableValue: newSelectedIndices
      });
    }
  }
  if (SVs.hidden) {
    return null;
  }
  let disabled = SVs.disabled;
  let label = SVs.label;
  if (SVs.labelHasLatex) {
    label = /* @__PURE__ */ jsxRuntimeExports.jsx(MathJax, { hideUntilTypeset: "first", inline: true, dynamic: true, children: label });
  }
  const description = SVs.description || void 0;
  if (SVs.inline) {
    let selectStyle = {};
    if (disabled) {
      selectStyle.cursor = "not-allowed";
      selectStyle.borderColor = getComputedStyle(
        document.documentElement
      ).getPropertyValue("--mainGray");
    }
    const checkWorkComponent = createCheckWorkComponent(
      SVs,
      id,
      validationState,
      submitAnswer,
      false
    );
    let svData = SVs;
    let optionsList = SVs.choiceTexts.map(function(s, i) {
      if (svData.choicesHidden[i]) {
        return null;
      }
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        "option",
        {
          value: i + 1,
          disabled: svData.choicesDisabled[i],
          children: s
        },
        i + 1
      );
    });
    let selectValue = rendererSelectedIndices === void 0 ? "" : !SVs.selectMultiple ? rendererSelectedIndices[0] ?? "" : rendererSelectedIndices;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(React__default.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "label",
        {
          style: { display: "inline-flex", maxWidth: "100%" },
          id: id + "-label",
          children: [
            label,
            /* @__PURE__ */ jsxRuntimeExports.jsxs(
              "select",
              {
                className: "custom-select",
                id,
                onChange: onChangeHandler,
                value: "" + selectValue,
                disabled,
                multiple: SVs.selectMultiple,
                style: selectStyle,
                "aria-label": description,
                children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx("option", { hidden: true, value: "", children: SVs.placeHolder }),
                  optionsList
                ]
              }
            )
          ]
        }
      ),
      checkWorkComponent
    ] });
  } else {
    let checkWorkComponent = createCheckWorkComponent(
      SVs,
      id,
      validationState,
      submitAnswer,
      true
    );
    let inputKey = id;
    let listStyle = {
      listStyleType: "none"
    };
    let keyBeginning = inputKey + "_choice";
    let inputType = "radio";
    if (SVs.selectMultiple) {
      inputType = "checkbox";
    }
    let svData = SVs;
    children = children.filter((child) => child !== null);
    let choiceDoenetTags = SVs.choiceOrder.map((v) => children[v - 1]).map(function(child, i) {
      if (svData.choicesHidden[i]) {
        return null;
      }
      if (inputType == "radio") {
        let radioDisabled = disabled || svData.choicesDisabled[i];
        let containerClassName = "radio-container";
        let radioClassName = "radio-checkmark";
        if (radioDisabled) {
          containerClassName += " radio-container-disabled";
          radioClassName += " radio-checkmark-disabled";
        }
        return /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "label",
          {
            className: containerClassName,
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "input",
                {
                  type: "radio",
                  id: keyBeginning + (i + 1) + "_input",
                  name: inputKey,
                  value: i + 1,
                  checked: rendererSelectedIndices.includes(
                    i + 1
                  ),
                  onChange: onChangeHandler,
                  disabled: radioDisabled
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: radioClassName }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "label",
                {
                  htmlFor: keyBeginning + (i + 1) + "_input",
                  style: { marginLeft: "2px" },
                  children: child
                }
              )
            ]
          },
          inputKey + "_choice" + (i + 1)
        ) });
      } else if (inputType == "checkbox") {
        let checkboxDisabled = disabled || svData.choicesDisabled[i];
        let containerClassName = "checkbox-container";
        let checkboxClassName = "checkbox-checkmark";
        if (checkboxDisabled) {
          containerClassName += " checkbox-container-disabled";
          checkboxClassName += " checkbox-checkmark-disabled";
        }
        return /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "label",
          {
            className: containerClassName,
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "input",
                {
                  type: "checkbox",
                  id: keyBeginning + (i + 1) + "_input",
                  name: inputKey,
                  value: i + 1,
                  checked: rendererSelectedIndices.includes(
                    i + 1
                  ),
                  onChange: onChangeHandler,
                  disabled: disabled || svData.choicesDisabled[i]
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: checkboxClassName }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                "label",
                {
                  htmlFor: keyBeginning + (i + 1) + "_input",
                  style: { marginLeft: "2px" },
                  children: child
                }
              )
            ]
          },
          inputKey + "_choice" + (i + 1)
        ) });
      }
    });
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { id: inputKey + "-label", children: [
      label,
      /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { id: inputKey, style: listStyle, children: choiceDoenetTags }),
      checkWorkComponent
    ] });
  }
});
export {
  choiceInput as default
};
